import { createFileRoute } from '@tanstack/react-router';
import { DataOwnersClient } from '@/features/data-owners/DataOwnersClient';

export const Route = createFileRoute('/_shell/data-owners/')({
  component: DataOwnersClient,
});
